export default __webpack_public_path__ + "static/media/autodrive_stop_circle.33ce835d.svg";